<div class="nsc-form-field-toggle {{classGroup}}" >
  <div class="nsc-form-field-toggle__label" [class.nsc-form-field-toggle__label--disabled]="disabled">
    <div class="mat-body-2 mat-hint" *ngIf="label">{{ label }}</div>
    <div class="mat-body-2 mat-hint" *ngIf="isHtmlContent" innerHtml="{{isHtmlContent}}"></div>
    <div class="mat-caption mat-hint">{{ note }}</div>
  </div>
  <div class="nsc-form-field-toggle__actions">
      <mat-radio-group class="radio-group" id="{{ idGroup}}" [attr.aria-required]="required" [attr.aria-label]="label ? label :isHtmlContent" >
        <mat-radio-button class="nsc-radio-button"
          id="{{idx}}_yes"
          value="YES"
          [disabled]=disabled
          [checked]="group.controls[controlName].value === values.yes"
          (change)="changeValue(values.yes)"
          (click)="clickBtn(values.yes)"
          [attr.aria-checked]="group.controls[controlName].value === values.yes">yes</mat-radio-button>
       <nsc-spacer horizontal="true"></nsc-spacer>
       <mat-radio-button class="nsc-radio-button"
          id="{{idx}}_no"
          value="NO" 
          [disabled]=disabled
          [checked]="group.controls[controlName].value === values.no"
          (change)="changeValue(values.no)"
          (click)="clickBtn(values.no)"
          [attr.aria-checked]="group.controls[controlName].value === values.no">no</mat-radio-button>
      </mat-radio-group>
    <!-- <button
      mat-button
      class="nsc-button"
      type="button"
      [attr.aria-pressed]="group.controls[controlName].value === values.yes"
      [class.selected]="group.controls[controlName].value === values.yes"
      [disabled]="disabled"
      (click)="changeValue(values.yes)">Yes</button>
    <nsc-spacer horizontal="true"></nsc-spacer>
    <button
      mat-button
      class="nsc-button"
      type="button"
      [attr.aria-pressed]="group.controls[controlName].value === values.no"
      [class.selected]="group.controls[controlName].value === values.no"
      [disabled]="disabled"
      (click)="changeValue(values.no)">No</button> -->
  </div>
  <div class="nsc-form-field-toggle__help" *ngIf="help">
    <mat-icon
    role="img"
    aria-hidden="false"
    aria-label="Information" 
      tabindex="0"
      (click)="openDialog()"
      (keyup.enter)="openDialog()"
      (keyup.space)="openDialog()">info</mat-icon>
  </div>
</div>
